<template>
    <div id="app">
        <Header>
        </Header>
        <div class="content">
            <router-view />
        </div>
        <Footer>
        </Footer>
    </div>
</template>
<script>
    import Header from "@/components/Header.vue";
    import Footer from "@/components/Footer.vue";
    import store from "@/store";

    export default {
        name: 'App',
        data: function () {
            return {
                store: store
            }
        },
        components: {
            Header,
            Footer
        }
    }
</script>

<style>
    @import url('https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap');

    body {
        margin: 0;
        background: #000;
        color: #FFF;
        font-family: 'Roboto', Arial;
    }

    body.noscroll {
        overflow: hidden;
    }

    a, a:visited, a:link {
        color: #FFF;
        text-decoration: none;
    }

    a:hover {
        text-decoration: underline;
    }

    .content {
        padding: 20px;
        max-width: 1920px;
        margin: 0 auto;
    }

    * {
        box-sizing: border-box;
    }

    .clearfix {
        display: block;
    }

    .clearfix:after, .cleafix:before {
        content: "";
        width: 0;
        height: 0;
        display: block;
        line-height: 0;
        overflow: hidden;
        clear: both;
    }
</style>
